module.exports = __webpack_public_path__ + "img/heure.bd297f42.png";